import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { IconProps } from '../../primitives/types.js';

/** Lowercase Greek pi (π) — the canonical mathematical constant glyph.
 *  Two vertical legs descending from a horizontal cap; the right leg
 *  curls outward at the foot, the left leg has a small foot-tick — a
 *  light typographic flourish to distinguish π from a generic "n". */
export function IcnPi(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="pi">
      <path d="M2.5 5 H13.5" />
      <path d="M5.5 5 L5 13" />
      <path d="M5 13 L4 13.5" />
      <path d="M10 5 V12 Q10 13 11.5 13" />
    </Svg>
  );
}
